import React from "react";
import WithLoadingSpinners from "../hoc/WithLoadingSpinner";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import getUrl from "../../functions/getUrl";
import { RouteComponentProps, withRouter } from "react-router";
import ContentList from "./ContentList";
import ITocItem from "../../models/ITocItem";
import { IApplicationState } from "../../store";
import { connect } from "react-redux";
import { selectAuth } from "../../store/auth/selectors";
import styled from "styled-components";
import { H3 } from "../Headers";
import getSection from "./getSection";
import getLocationInfo, { Product } from "../../functions/getLocationInfo";
import transformToc from "../../functions/transformToc";
import IContentsItem from "../../models/IContentsItem";
import Fetch from "../../services/Fetch";
import SidebarHeaderMenu from "./SidebarHeaderMenu";

const SectionTitle = styled(H3)`
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0 0 20px;
`;

interface ILocalSideMenuProps extends RouteComponentProps {
  id: string;
  toc?: ITocItem;
  contentId: string;
  token: string;
  onLoaded?: (items: IContentsItem[]) => void;
}

const LocalSideMenu = (props: ILocalSideMenuProps) => {
  const { id, token, onLoaded, contentId, location } = props;
  const [prevId, setPrevId] = React.useState<string | undefined>();
  const [rawContent, setRawContent] = React.useState<ITocItem[] | undefined>();
  const [content, setContent] = React.useState<IContentsItem[] | undefined>();
  const [error, setError] = React.useState<string | Error | undefined>();

  React.useEffect(() => {
    let toc: any = null;
    const refresh = async () => {
      try {
        if (id !== prevId || !rawContent) {
          setPrevId(id);
          if (!token) {
            throw new Error("Unable to load: Unauthorized");
          }
          const name = encodeURIComponent(id);
          const url = getUrl(`/docfx?name=${name}`);
          const resp = await Fetch(url, undefined, token);
          if (!resp.ok) {
            throw new Error(`${resp.status} - ${resp.statusText || "Unknown error"}`);
          }
          toc = await resp.json();
          setRawContent(toc);
        }

        const transformed = transformToc(toc || rawContent, id, contentId);

        setContent(transformed);
        if (onLoaded) {
          onLoaded(transformed);
        }
      } catch (error) {
        setError(error);
      }
    };
    refresh();
  }, [id, contentId, token]);

  const { doc } = getLocationInfo(location);

  let title: string | null = null;
  if (doc && doc.id === "index.html") {
    title = "☝️ Choose a product to get started! 🚀";
  }

  return (
    <>
      <SidebarHeaderMenu />
      <WithLoadingSpinners isLoading={!content} error={error} setError={(err: string | Error) => setError(err)} message="Fetching menu...">
        <ScrollToTopOnMount />
        <div>
          {title && <SectionTitle>{title}</SectionTitle>}
          {!title && content && content.map(toc => <ContentList key={`${toc.name}::${toc.href}`} {...toc} />)}
        </div>
      </WithLoadingSpinners>
    </>
  );
};

export default connect((state: IApplicationState) => {
  return selectAuth(state);
})(withRouter(LocalSideMenu));
